import React, { useState, useEffect, useRef } from "react";
import { supabase } from './supabase.js'; // Importamos Supabase

const colores = ["red", "blue", "green", "yellow", "orange", "purple"];
const nombres = {
  en: {
    red: "RED",
    blue: "BLUE", 
    green: "GREEN",
    yellow: "YELLOW",
    orange: "ORANGE",
    purple: "PURPLE",
  },
  es: {
    red: "ROJO",
    blue: "AZUL",
    green: "VERDE", 
    yellow: "AMARILLO",
    orange: "NARANJA",
    purple: "MORADO",
  },
};

const textos = {
  en: {
    start: "Start",
    restart: "Restart", 
    level: "Level",
    lives: "Lives",
    time: "Time",
    rankup: "Rank Up! 🏅",
    selectLanguage: "Select language",
    congrats: "🎉 Congratulations! You reached the goal! 🎉",
    gameOver: "🎮 GAME OVER 🎮",
    retry: "RETRY",
    reachedLevel: "Reached level",
    playerName: "Player Name",
    enterName: "Enter your nickname",
    country: "Country",
    selectCountry: "Select your country",
    continue: "Continue to Game",
    nameRequired: "Name is required",
    countryRequired: "Country is required",
    welcome: "Welcome",
    player: "Player",
    viewBestPlayers: "VIEW BEST PLAYERS",
    leaderboard: "LEADERBOARD",
    ranking: "Ranking",
    global: "Global",
    byCountry: "By Country",
    noRecords: "No records yet",
    position: "Position",
    level: "Level",
    time: "Time",
    back: "Back",
    play: "Play",
    filter: "Filter",
    share: "SHARE SCORE",
    shareTitle: "I CHALLENGE YOU! 🏆",
    shareChallenge: "Can you beat my score?",
    top10: "TOP 10",
    top25: "TOP 25", 
    top50: "TOP 50",
    top100: "TOP 100",
    selectCountryFilter: "Select country",
    globalRanking: "Global Ranking",
    countryRanking: "Country Ranking"
  },
  es: {
    start: "Iniciar",
    restart: "Reiniciar",
    level: "Nivel",
    lives: "Vidas", 
    time: "Tiempo",
    rankup: "¡Subes de rango! 🏅",
    selectLanguage: "Selecciona idioma",
    congrats: "🎉 ¡Felicidades, has llegado a la meta! 🎉",
    gameOver: "🎮 GAME OVER 🎮",
    retry: "REINTENTAR",
    reachedLevel: "Llegaste al nivel",
    playerName: "Nombre del Jugador",
    enterName: "Ingresa tu apodo",
    country: "País",
    selectCountry: "Selecciona tu país",
    continue: "Continuar al Juego",
    nameRequired: "El nombre es obligatorio",
    countryRequired: "El país es obligatorio",
    welcome: "Bienvenido",
    player: "Jugador",
    viewBestPlayers: "VER MEJORES JUGADORES",
    leaderboard: "TABLA DE LÍDERES",
    ranking: "Clasificación",
    global: "Global",
    byCountry: "Por País",
    noRecords: "Aún no hay records",
    position: "Posición",
    level: "Nivel",
    time: "Tiempo",
    back: "Volver",
    play: "Jugar",
    filter: "Filtrar",
    share: "COMPARTIR PUNTAJE",
    shareTitle: "¡TE RETO! 🏆",
    shareChallenge: "¿Podrás superar mi marca?",
    top10: "TOP 10",
    top25: "TOP 25",
    top50: "TOP 50", 
    top100: "TOP 100",
    selectCountryFilter: "Selecciona país",
    globalRanking: "Ranking Global",
    countryRanking: "Ranking por País"
  },
};

// Lista de países latinoamericanos y otros populares
const paises = [
  "Argentina", "Bolivia", "Brasil", "Chile", "Colombia", "Costa Rica", 
  "Cuba", "República Dominicana", "Ecuador", "El Salvador", "Guatemala",
  "Honduras", "México", "Nicaragua", "Panamá", "Paraguay", "Perú", 
  "Puerto Rico", "Uruguay", "Venezuela", "España", "Estados Unidos",
  "Canadá", "Otro"
];

// Banderas para países (emojis)
const banderas = {
  "Argentina": "🇦🇷", "Bolivia": "🇧🇴", "Brasil": "🇧🇷", "Chile": "🇨🇱", 
  "Colombia": "🇨🇴", "Costa Rica": "🇨🇷", "Cuba": "🇨🇺", 
  "República Dominicana": "🇩🇴", "Ecuador": "🇪🇨", "El Salvador": "🇸🇻",
  "Guatemala": "🇬🇹", "Honduras": "🇭🇳", "México": "🇲🇽", 
  "Nicaragua": "🇳🇮", "Panamá": "🇵🇦", "Paraguay": "🇵🇾", 
  "Perú": "🇵🇪", "Puerto Rico": "🇵🇷", "Uruguay": "🇺🇾", 
  "Venezuela": "🇻🇪", "España": "🇪🇸", "Estados Unidos": "🇺🇸",
  "Canadá": "🇨🇦", "Otro": "🌎"
};

// Niveles donde cambia la velocidad (y muestra Rank Up)
const nivelesCambioVelocidad = [11, 21, 41, 61, 101, 121];

// Función para obtener badge según posición
const obtenerBadge = (posicion) => {
  if (posicion === 1) return "👑";
  if (posicion <= 10) return "⭐";
  if (posicion <= 25) return "🔥";
  if (posicion <= 50) return "🚀";
  if (posicion <= 100) return "🎯";
  return "";
};

export default function App() {
  const [idioma, setIdioma] = useState("es");
  const [pantallaInicio, setPantallaInicio] = useState(true);
  const [pantallaRegistro, setPantallaRegistro] = useState(false);
  const [pantallaLeaderboard, setPantallaLeaderboard] = useState(false);
  const [nivel, setNivel] = useState(1);
  const [colorTexto, setColorTexto] = useState("");
  const [texto, setTexto] = useState("");
  const [vidas, setVidas] = useState(10);
  const [inicio, setInicio] = useState(false);
  const [tiempo, setTiempo] = useState(0);
  const [mostrarRango, setMostrarRango] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  
  // ESTADOS PARA LAS MEJORAS
  const [tapEnProgreso, setTapEnProgreso] = useState(false);
  const [feedback, setFeedback] = useState({ tipo: null, visible: false });
  
  // Estados para el registro del jugador
  const [nombreJugador, setNombreJugador] = useState("");
  const [paisJugador, setPaisJugador] = useState("");
  const [errores, setErrores] = useState({ nombre: "", pais: "" });

  // Estados para el leaderboard
  const [filtroLeaderboard, setFiltroLeaderboard] = useState("global");
  const [paisFiltro, setPaisFiltro] = useState("");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [cargandoLeaderboard, setCargandoLeaderboard] = useState(false);
  const [miPosicionGlobal, setMiPosicionGlobal] = useState(null);

  // Estado para controlar la pantalla de share
  const [mostrarShare, setMostrarShare] = useState(false);

  const cronometro = useRef(null);
  
  // REF MEJORADO PARA EVITAR DOBLE TAP
  const ultimaCombinacionRef = useRef({ 
    texto: '', 
    color: '', 
    procesando: false,
    ultimoTap: 0
  });
  
  // CONFIGURACIÓN DE VELOCIDADES
  const obtenerVelocidad = (nivel) => {
    if (nivel <= 10) return 1500;
    if (nivel <= 20) return 1200;
    if (nivel <= 40) return 800;
    if (nivel <= 60) return 700;
    if (nivel <= 100) return 600;
    if (nivel <= 120) return 500;
    return 400;
  };

  // FUNCIONES PARA SUPABASE

  // Función para guardar partida en Supabase
  const guardarPartida = async (nivelAlcanzado, tiempoJugado, vidasRestantes) => {
    console.log('🔄 guardarPartida EJECUTADA', {
      nombre: nombreJugador,
      pais: paisJugador,
      nivel: nivelAlcanzado,
      tiempo: tiempoJugado,
      vidas: vidasRestantes
    });

    try {
      // Calcular porcentaje de aciertos aproximado
      const porcentajeAciertos = Math.min(100, Math.max(0, 
        ((nivelAlcanzado - 1) / 19) * 100 + (Math.random() * 10 - 5)
      )).toFixed(2);

      // Calcular puntuación
      const puntuacion = (nivelAlcanzado * 100) - tiempoJugado;

      console.log('📊 Datos a guardar:', {
        player_name: nombreJugador,
        country: paisJugador,
        level_reached: nivelAlcanzado,
        time_played: tiempoJugado,
        score: puntuacion,
        lives_left: vidasRestantes,
        accuracy_percentage: parseFloat(porcentajeAciertos)
      });

      const { data, error } = await supabase
        .from('player_records')
        .insert([
          {
            player_name: nombreJugador,
            country: paisJugador,
            level_reached: nivelAlcanzado,
            time_played: tiempoJugado,
            score: puntuacion,
            lives_left: vidasRestantes,
            accuracy_percentage: parseFloat(porcentajeAciertos)
          }
        ]);

      if (error) {
        console.error('❌ Error guardando partida:', error);
        return false;
      }
      
      console.log('✅ Partida guardada exitosamente:', data);
      
      // Obtener y guardar posición global después de guardar
      await obtenerMiPosicionGlobal(puntuacion);
      
      return true;
    } catch (error) {
      console.error('❌ Error:', error);
      return false;
    }
  };

  // Función: Obtener mi posición global
  const obtenerMiPosicionGlobal = async (miPuntuacion) => {
    try {
      const { data, error } = await supabase
        .from('player_records')
        .select('score')
        .order('score', { ascending: false });

      if (error) {
        console.error('❌ Error obteniendo posición:', error);
        return;
      }

      // Encontrar mi posición basado en mi puntuación
      const posicion = data.findIndex(record => record.score <= miPuntuacion) + 1;
      setMiPosicionGlobal(posicion);
      console.log('🎯 Mi posición global:', posicion);
      
    } catch (error) {
      console.error('❌ Error:', error);
    }
  };

  // Función: Obtener leaderboard de Supabase (TOP 100)
  const obtenerLeaderboard = async (filtro = 'global', paisSeleccionado = '') => {
    console.log('🔍 Obteniendo leaderboard...', filtro, paisSeleccionado);
    setCargandoLeaderboard(true);
    try {
      let query = supabase
        .from('player_records')
        .select('*')
        .order('score', { ascending: false })
        .limit(100);

      if (filtro === 'pais' && paisSeleccionado) {
        query = query.eq('country', paisSeleccionado);
      }

      const { data, error } = await query;

      if (error) {
        console.error('❌ Error obteniendo leaderboard:', error);
        return [];
      }

      console.log('✅ Leaderboard obtenido:', data?.length || 0, 'registros');
      return data || [];
    } catch (error) {
      console.error('❌ Error:', error);
      return [];
    } finally {
      setCargandoLeaderboard(false);
    }
  };

  // FUNCIONES: Compartir en redes sociales
  const compartirTwitter = () => {
    const posicionTexto = miPosicionGlobal ? `🏆 Posición #${miPosicionGlobal} en el Top Global` : "🏆 ¡Nuevo record personal!";
    
    const mensaje = `${textos[idioma].shareTitle}\n\n👤 ${nombreJugador}\n${banderas[paisJugador]} ${paisJugador}\n⭐ Nivel ${nivel}\n⏱️ ${tiempo} segundos\n${posicionTexto}\n\n${textos[idioma].shareChallenge}\n\n🔗 https://www.colorblink.com/\n#RetoDeColores`;
    
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(mensaje)}`;
    window.open(twitterUrl, '_blank', 'width=600,height=400');
  };

  const compartirFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://www.colorblink.com/')}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  // Función: WhatsApp con Web Share API
  const compartirWhatsApp = async () => {
    // Primero intentar con Web Share API (más moderno)
    if (navigator.share) {
      try {
        const posicionTexto = miPosicionGlobal ? `🏆 Posición #${miPosicionGlobal} en el Top Global` : "🏆 ¡Nuevo record personal!";
        
        await navigator.share({
          title: textos[idioma].shareTitle,
          text: `${textos[idioma].shareTitle}\n\n👤 ${nombreJugador}\n${banderas[paisJugador]} ${paisJugador}\n⭐ Nivel ${nivel}\n⏱️ ${tiempo} segundos\n${posicionTexto}\n\n${textos[idioma].shareChallenge}`,
          url: 'https://www.colorblink.com/',
        });
        return;
      } catch (error) {
        console.log('Web Share API cancelado o no soportado:', error);
      }
    }
    
    // Fallback al método tradicional de WhatsApp
    const posicionTexto = miPosicionGlobal ? `🏆 Posición #${miPosicionGlobal} en el Top Global` : "🏆 ¡Nuevo record personal!";
    
    const mensaje = `${textos[idioma].shareTitle}%0A%0A👤 ${nombreJugador}%0A${banderas[paisJugador]} ${paisJugador}%0A⭐ Nivel ${nivel}%0A⏱️ ${tiempo} segundos%0A${posicionTexto}%0A%0A${textos[idioma].shareChallenge}%0A%0A🔗 https://www.colorblink.com/%0A%23RetoDeColores`;
    
    window.open(`https://wa.me/?text=${mensaje}`, '_blank');
  };

  const copiarPortapapeles = () => {
    const posicionTexto = miPosicionGlobal ? `🏆 Posición #${miPosicionGlobal} en el Top Global` : "🏆 ¡Nuevo record personal!";
    
    const mensaje = `${textos[idioma].shareTitle}\n\n👤 ${nombreJugador}\n${banderas[paisJugador]} ${paisJugador}\n⭐ Nivel ${nivel}\n⏱️ ${tiempo} segundos\n${posicionTexto}\n\n${textos[idioma].shareChallenge}\n\n🔗 https://www.colorblink.com/\n#RetoDeColores`;
    
    navigator.clipboard.writeText(mensaje).then(() => {
      alert('¡Puntuación copiada al portapapeles!');
    }).catch(() => {
      const textArea = document.createElement('textarea');
      textArea.value = mensaje;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('¡Puntuación copiada al portapapeles!');
    });
  };

  // CARGA OPTIMIZADA DEL LEADERBOARD
  useEffect(() => {
    const cargarLeaderboard = async () => {
      const datosReales = await obtenerLeaderboard(filtroLeaderboard, paisFiltro);
      setLeaderboardData(datosReales);
    };
    
    if (pantallaLeaderboard) {
      // Inicializar país filtro con el país del jugador
      if (!paisFiltro && paisJugador) {
        setPaisFiltro(paisJugador);
      }
      cargarLeaderboard();
    }
  }, [pantallaLeaderboard, filtroLeaderboard, paisFiltro]);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);
    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  // INTERVALO DEL CRONÓMETRO
  useEffect(() => {
    if (inicio && !gameOver) {
      cronometro.current = setInterval(() => setTiempo((t) => t + 1), 1000);
    }
    return () => {
      if (cronometro.current) {
        clearInterval(cronometro.current);
        cronometro.current = null;
      }
    };
  }, [inicio, gameOver]);

  // INTERVALO PRINCIPAL
  useEffect(() => {
    if (!inicio || gameOver) return;
    
    const generarCombinacion = () => {
      const dict = nombres[idioma];
      let nuevoColor, nuevoTexto;
      const prob = 0.4;

      if (Math.random() < prob) {
        const colorCoincidente = colores[Math.floor(Math.random() * colores.length)];
        nuevoColor = colorCoincidente;
        nuevoTexto = dict[colorCoincidente];
      } else {
        nuevoColor = colores[Math.floor(Math.random() * colores.length)];
        const coloresDisponibles = colores.filter(color => dict[color] !== dict[nuevoColor]);
        nuevoTexto = dict[coloresDisponibles[Math.floor(Math.random() * coloresDisponibles.length)]];
      }

      setColorTexto(nuevoColor);
      setTexto(nuevoTexto);
    };

    const velocidad = obtenerVelocidad(nivel);
    const intervalo = setInterval(generarCombinacion, velocidad);
    
    return () => clearInterval(intervalo);
  }, [inicio, nivel, idioma, gameOver]);

  // ✅ FUNCIÓN CORREGIDA PARA CHROME ANDROID
  const manejarTapMejorado = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const ahora = Date.now();
    
    if (!inicio || vidas === 0 || gameOver || 
        tapEnProgreso || 
        ultimaCombinacionRef.current.procesando ||
        (ahora - ultimaCombinacionRef.current.ultimoTap < 250)) {
      return;
    }
    
    ultimaCombinacionRef.current.procesando = true;
    ultimaCombinacionRef.current.ultimoTap = ahora;
    setTapEnProgreso(true);
    
    const textoAlMomentoDelTap = texto;
    const colorAlMomentoDelTap = colorTexto;
    const dict = nombres[idioma];
    
    setTexto("");
    setColorTexto("");
    
    const acierto = textoAlMomentoDelTap.toLowerCase() === dict[colorAlMomentoDelTap].toLowerCase();

    if (acierto) {
      setFeedback({ tipo: 'acierto', visible: true });
      
      const nuevoNivel = nivel + 1;
      setNivel(nuevoNivel);

      if (nivelesCambioVelocidad.includes(nuevoNivel)) {
        setMostrarRango(true);
        setTimeout(() => setMostrarRango(false), 1500);
      }

    } else {
      setFeedback({ tipo: 'fallo', visible: true });
      
      const nuevasVidas = vidas - 1;
      setVidas(nuevasVidas);
      
      if (nuevasVidas === 0) {
        setGameOver(true);
        setInicio(false);
        guardarPartida(nivel, tiempo, nuevasVidas);
      }
    }
    
    setTimeout(() => {
      ultimaCombinacionRef.current.procesando = false;
      setTapEnProgreso(false);
      setFeedback({ tipo: null, visible: false });
    }, 300);
  };

  const reiniciarJuego = () => {
    setNivel(1);
    setVidas(10);
    setTiempo(0);
    setInicio(false);
    setGameOver(false);
    setMostrarRango(false);
    setMostrarShare(false);
    setColorTexto("");
    setTexto("");
    setTapEnProgreso(false);
    setFeedback({ tipo: null, visible: false });
    
    // LIMPIAR REF COMPLETAMENTE
    ultimaCombinacionRef.current = { 
      texto: '', 
      color: '', 
      procesando: false,
      ultimoTap: 0
    };
    
    if (cronometro.current) {
      clearInterval(cronometro.current);
      cronometro.current = null;
    }
  };

  // Función para manejar el registro del jugador
  const manejarRegistro = () => {
    const nuevosErrores = { nombre: "", pais: "" };
    
    if (!nombreJugador.trim()) {
      nuevosErrores.nombre = textos[idioma].nameRequired;
    }
    
    if (!paisJugador) {
      nuevosErrores.pais = textos[idioma].countryRequired;
    }
    
    setErrores(nuevosErrores);
    
    if (!nuevosErrores.nombre && !nuevosErrores.pais) {
      setPantallaRegistro(false);
    }
  };

  // PANTALLA DE INICIO (SELECCIÓN DE IDIOMA)
  if (pantallaInicio) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}
      >
        <h1 style={{ color: "limegreen", fontSize: '2rem', marginBottom: '2rem' }}>
          {textos[idioma].selectLanguage}
        </h1>

        <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            onClick={() => setIdioma("es")}
            style={{
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: idioma === "es" ? "#16a34a" : "#4b5563",
              color: 'white',
              cursor: 'pointer',
              minWidth: '140px'
            }}
          >
            🇪🇸 Español
          </button>
          <button
            onClick={() => setIdioma("en")}
            style={{
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: idioma === "en" ? "#2563eb" : "#4b5563",
              color: 'white',
              cursor: 'pointer',
              minWidth: '140px'
            }}
          >
            🇺🇸 English
          </button>
        </div>

        <button
          onClick={() => {
            setPantallaInicio(false);
            setPantallaRegistro(true);
          }}
          style={{
            backgroundColor: '#eab308',
            padding: '16px 32px',
            fontSize: '1.25rem',
            borderRadius: '8px',
            border: 'none',
            color: 'black',
            cursor: 'pointer',
            fontWeight: 'bold',
            minWidth: '200px',
            marginBottom: '1rem'
          }}
        >
          {textos[idioma].start}
        </button>
      </div>
    );
  }

  // PANTALLA LEADERBOARD
  if (pantallaLeaderboard) {
    // Agrupar jugadores por rangos
    const jugadoresAgrupados = {
      top10: leaderboardData.slice(0, 10),
      top25: leaderboardData.slice(10, 25),
      top50: leaderboardData.slice(25, 50),
      top100: leaderboardData.slice(50, 100)
    };

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          textAlign: 'center',
          overflowY: 'auto'
        }}
      >
        <h1 style={{ color: "#eab308", fontSize: '2rem', marginBottom: '1rem' }}>
          🏆 {textos[idioma].leaderboard} 🏆
        </h1>

        {/* Título del ranking */}
        <div style={{ color: '#4ade80', fontSize: '1.2rem', marginBottom: '1rem', fontWeight: 'bold' }}>
          {filtroLeaderboard === 'global' ? textos[idioma].globalRanking : textos[idioma].countryRanking}
        </div>

        {/* Filtros */}
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            onClick={() => setFiltroLeaderboard("global")}
            style={{
              padding: '10px 20px',
              fontSize: '1rem',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: filtroLeaderboard === "global" ? '#2563eb' : '#4b5563',
              color: 'white',
              cursor: 'pointer',
              fontWeight: filtroLeaderboard === "global" ? 'bold' : 'normal'
            }}
          >
            🌍 {textos[idioma].global}
          </button>
          <button
            onClick={() => setFiltroLeaderboard("pais")}
            style={{
              padding: '10px 20px',
              fontSize: '1rem',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: filtroLeaderboard === "pais" ? '#16a34a' : '#4b5563',
              color: 'white',
              cursor: 'pointer',
              fontWeight: filtroLeaderboard === "pais" ? 'bold' : 'normal'
            }}
          >
            {banderas[paisFiltro] || '🇬🇹'} {textos[idioma].byCountry}
          </button>
        </div>

        {/* Selector de países (solo visible en filtro por país) */}
        {filtroLeaderboard === "pais" && (
          <div style={{ marginBottom: '1.5rem', width: '100%', maxWidth: '300px' }}>
            <select
              value={paisFiltro}
              onChange={(e) => setPaisFiltro(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 16px',
                fontSize: '1rem',
                borderRadius: '8px',
                border: '2px solid #4b5563',
                backgroundColor: '#1f2937',
                color: 'white',
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              <option value="">{textos[idioma].selectCountryFilter}</option>
              {paises.map((pais) => (
                <option key={pais} value={pais}>
                  {banderas[pais]} {pais}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Tabla de Leaderboard */}
        <div style={{
          width: '100%',
          maxWidth: '800px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          padding: '1rem',
          marginBottom: '1.5rem',
          maxHeight: '70vh',
          overflowY: 'auto'
        }}>
          {cargandoLeaderboard ? (
            <div style={{
              padding: '2rem',
              color: '#9ca3af',
              fontSize: '1.1rem'
            }}>
              Cargando datos...
            </div>
          ) : leaderboardData.length > 0 ? (
            <div>
              {/* TOP 10 con diseño especial */}
              {jugadoresAgrupados.top10.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div style={{
                    color: '#fbbf24',
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: 'rgba(251, 191, 36, 0.1)',
                    borderRadius: '8px'
                  }}>
                    🎖️ {textos[idioma].top10} (1-10)
                  </div>
                  {jugadoresAgrupados.top10.map((jugador, index) => (
                    <div
                      key={jugador.id || index}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '50px 50px 1fr 80px 80px 60px',
                        gap: '0.5rem',
                        padding: '0.75rem 0.5rem',
                        borderBottom: '1px solid #374151',
                        alignItems: 'center',
                        backgroundColor: index % 2 === 0 ? 'rgba(255, 255, 255, 0.05)' : 'transparent'
                      }}
                    >
                      <div style={{
                        fontWeight: 'bold',
                        color: index === 0 ? '#facc15' : index === 1 ? '#cbd5e1' : index === 2 ? '#d97706' : '#9ca3af'
                      }}>
                        {index + 1}
                      </div>
                      <div style={{ fontSize: '1.2rem' }}>
                        {obtenerBadge(index + 1)}
                      </div>
                      <div style={{ textAlign: 'left', fontWeight: 'bold' }}>{jugador.player_name}</div>
                      <div style={{ color: '#4ade80', fontWeight: 'bold' }}>{jugador.level_reached}</div>
                      <div style={{ color: '#60a5fa' }}>{jugador.time_played}s</div>
                      <div>{banderas[jugador.country]}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* TOP 25 */}
              {jugadoresAgrupados.top25.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div style={{
                    color: '#cbd5e1',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: 'rgba(203, 213, 225, 0.1)',
                    borderRadius: '8px'
                  }}>
                    🥇 {textos[idioma].top25} (11-25)
                  </div>
                  {jugadoresAgrupados.top25.map((jugador, index) => (
                    <div
                      key={jugador.id || index + 10}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '50px 50px 1fr 80px 80px 60px',
                        gap: '0.5rem',
                        padding: '0.6rem 0.5rem',
                        borderBottom: '1px solid #374151',
                        alignItems: 'center',
                        fontSize: '0.9rem',
                        backgroundColor: (index + 10) % 2 === 0 ? 'rgba(255, 255, 255, 0.05)' : 'transparent'
                      }}
                    >
                      <div style={{ fontWeight: 'bold', color: '#9ca3af' }}>
                        {index + 11}
                      </div>
                      <div style={{ fontSize: '1.1rem' }}>
                        {obtenerBadge(index + 11)}
                      </div>
                      <div style={{ textAlign: 'left' }}>{jugador.player_name}</div>
                      <div style={{ color: '#4ade80' }}>{jugador.level_reached}</div>
                      <div style={{ color: '#60a5fa' }}>{jugador.time_played}s</div>
                      <div>{banderas[jugador.country]}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* TOP 50 */}
              {jugadoresAgrupados.top50.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div style={{
                    color: '#d97706',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: 'rgba(217, 119, 6, 0.1)',
                    borderRadius: '8px'
                  }}>
                    🥈 {textos[idioma].top50} (26-50)
                  </div>
                  {jugadoresAgrupados.top50.map((jugador, index) => (
                    <div
                      key={jugador.id || index + 25}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '50px 50px 1fr 80px 80px 60px',
                        gap: '0.5rem',
                        padding: '0.5rem 0.5rem',
                        borderBottom: '1px solid #374151',
                        alignItems: 'center',
                        fontSize: '0.85rem',
                        backgroundColor: (index + 25) % 2 === 0 ? 'rgba(255, 255, 255, 0.05)' : 'transparent'
                      }}
                    >
                      <div style={{ fontWeight: 'bold', color: '#6b7280' }}>
                        {index + 26}
                      </div>
                      <div style={{ fontSize: '1rem' }}>
                        {obtenerBadge(index + 26)}
                      </div>
                      <div style={{ textAlign: 'left' }}>{jugador.player_name}</div>
                      <div style={{ color: '#4ade80' }}>{jugador.level_reached}</div>
                      <div style={{ color: '#60a5fa' }}>{jugador.time_played}s</div>
                      <div>{banderas[jugador.country]}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* TOP 100 */}
              {jugadoresAgrupados.top100.length > 0 && (
                <div style={{ marginBottom: '1rem' }}>
                  <div style={{
                    color: '#6b7280',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: 'rgba(107, 114, 128, 0.1)',
                    borderRadius: '8px'
                  }}>
                    🥉 {textos[idioma].top100} (51-100)
                  </div>
                  {jugadoresAgrupados.top100.map((jugador, index) => (
                    <div
                      key={jugador.id || index + 50}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '50px 50px 1fr 80px 80px 60px',
                        gap: '0.5rem',
                        padding: '0.4rem 0.5rem',
                        borderBottom: '1px solid #374151',
                        alignItems: 'center',
                        fontSize: '0.8rem',
                        backgroundColor: (index + 50) % 2 === 0 ? 'rgba(255, 255, 255, 0.05)' : 'transparent'
                      }}
                    >
                      <div style={{ fontWeight: 'bold', color: '#6b7280' }}>
                        {index + 51}
                      </div>
                      <div style={{ fontSize: '0.9rem' }}>
                        {obtenerBadge(index + 51)}
                      </div>
                      <div style={{ textAlign: 'left' }}>{jugador.player_name}</div>
                      <div style={{ color: '#4ade80' }}>{jugador.level_reached}</div>
                      <div style={{ color: '#60a5fa' }}>{jugador.time_played}s</div>
                      <div>{banderas[jugador.country]}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div style={{
              padding: '2rem',
              color: '#9ca3af',
              fontSize: '1.1rem'
            }}>
              {textos[idioma].noRecords}
            </div>
          )}
        </div>

        {/* Botones */}
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1rem' }}>
          <button
            onClick={() => setPantallaLeaderboard(false)}
            style={{
              backgroundColor: '#6b7280',
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              minWidth: '140px'
            }}
          >
            ← {textos[idioma].back}
          </button>
          
          <button
            onClick={() => {
              setPantallaLeaderboard(false);
              setPantallaRegistro(false);
            }}
            style={{
              backgroundColor: '#16a34a',
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold',
              minWidth: '140px'
            }}
          >
            🎮 {textos[idioma].play}
          </button>
        </div>
      </div>
    );
  }

  // PANTALLA DE REGISTRO DEL JUGADOR
  if (pantallaRegistro) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          textAlign: 'center'
        }}
      >
        <h1 style={{ color: "#eab308", fontSize: '2rem', marginBottom: '2rem' }}>
          {textos[idioma].welcome} 👤
        </h1>

        <div style={{ width: '100%', maxWidth: '400px', marginBottom: '2rem' }}>
          {/* Campo Nombre */}
          <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', color: '#4ade80', fontSize: '1.1rem' }}>
              {textos[idioma].playerName} *
            </label>
            <input
              type="text"
              value={nombreJugador}
              onChange={(e) => {
                setNombreJugador(e.target.value);
                if (errores.nombre) setErrores({...errores, nombre: ""});
              }}
              placeholder={textos[idioma].enterName}
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '1.1rem',
                borderRadius: '8px',
                border: `2px solid ${errores.nombre ? '#ef4444' : '#4b5563'}`,
                backgroundColor: '#1f2937',
                color: 'white',
                outline: 'none'
              }}
              maxLength={20}
            />
            {errores.nombre && (
              <div style={{ color: '#ef4444', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                {errores.nombre}
              </div>
            )}
          </div>

          {/* Campo País */}
          <div style={{ marginBottom: '2rem', textAlign: 'left' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', color: '#4ade80', fontSize: '1.1rem' }}>
              {textos[idioma].country} *
            </label>
            <select
              value={paisJugador}
              onChange={(e) => {
                setPaisJugador(e.target.value);
                if (errores.pais) setErrores({...errores, pais: ""});
              }}
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '1.1rem',
                borderRadius: '8px',
                border: `2px solid ${errores.pais ? '#ef4444' : '#4b5563'}`,
                backgroundColor: '#1f2937',
                color: 'white',
                outline: 'none',
                cursor: 'pointer'
              }}
            >
              <option value="">{textos[idioma].selectCountry}</option>
              {paises.map((pais) => (
                <option key={pais} value={pais}>
                  {pais}
                </option>
              ))}
            </select>
            {errores.pais && (
              <div style={{ color: '#ef4444', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                {errores.pais}
              </div>
            )}
          </div>
        </div>

        {/* Botones */}
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1rem' }}>
          <button
            onClick={() => {
              setPantallaRegistro(false);
              setPantallaInicio(true);
            }}
            style={{
              backgroundColor: '#6b7280',
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              minWidth: '140px'
            }}
          >
            ← {textos[idioma].back}
          </button>
          
          <button
            onClick={manejarRegistro}
            style={{
              backgroundColor: '#16a34a',
              padding: '12px 24px',
              fontSize: '1.1rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold',
              minWidth: '140px'
            }}
          >
            {textos[idioma].continue} →
          </button>
        </div>

        {/* Botón VER MEJORES JUGADORES */}
        <button
          onClick={() => {
            // Validar antes de mostrar leaderboard
            if (!nombreJugador.trim() || !paisJugador) {
              setErrores({
                nombre: !nombreJugador.trim() ? textos[idioma].nameRequired : "",
                pais: !paisJugador ? textos[idioma].countryRequired : ""
              });
              return;
            }
            
            // Si todo está bien, mostrar leaderboard
            setErrores({ nombre: "", pais: "" });
            setPaisFiltro(paisJugador);
            setPantallaLeaderboard(true);
          }}
          style={{
            backgroundColor: '#7c3aed',
            padding: '12px 24px',
            fontSize: '1.1rem',
            borderRadius: '8px',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold',
            minWidth: '200px',
            marginBottom: '1rem'
          }}
        >
          {textos[idioma].viewBestPlayers}
        </button>

        {/* Información del jugador (preview) */}
        {nombreJugador && paisJugador && (
          <div style={{
            marginTop: '1rem',
            padding: '1rem',
            backgroundColor: 'rgba(74, 222, 128, 0.1)',
            borderRadius: '8px',
            border: '1px solid #4ade80'
          }}>
            <div style={{ color: '#4ade80', fontSize: '1rem' }}>
              {textos[idioma].player}: <strong>{nombreJugador}</strong> - {paisJugador} {banderas[paisJugador]}
            </div>
          </div>
        )}
      </div>
    );
  }

  // PANTALLA PRINCIPAL DEL JUEGO - CORREGIDA PARA CHROME ANDROID
  return (
    <div
      onClick={manejarTapMejorado}
      onTouchStart={manejarTapMejorado} // ✅ NUEVO: EVENTO TÁCTIL
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'black',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white',
        fontFamily: 'Arial, sans-serif',
        padding: '1rem 0',
        overflow: 'hidden',
        cursor: tapEnProgreso ? 'not-allowed' : 'pointer',
        // ✅ NUEVOS ESTILOS PARA CHROME ANDROID
        WebkitTapHighlightColor: 'transparent',
        WebkitTouchCallout: 'none',
        WebkitUserSelect: 'none',
        userSelect: 'none',
        touchAction: 'manipulation'
      }}
    >
      {/* HUD Superior con INFO DEL JUGADOR */}
      <div style={{
        width: '100%',
        maxWidth: '800px',
        padding: '0 1rem'
      }}>
        {/* Línea 1: Nombre y País */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#eab308',
          fontSize: '1rem',
          fontWeight: '600',
          padding: '0.5rem 0.75rem',
          backgroundColor: 'rgba(0,0,0,0.5)',
          borderRadius: '8px 8px 0 0',
          borderBottom: '1px solid #374151'
        }}>
          <span style={{ 
            textAlign: 'center',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '300px'
          }}>
            {nombreJugador || textos[idioma].player} - {paisJugador || textos[idioma].country} {banderas[paisJugador]}
          </span>
        </div>

        {/* Línea 2: Stats del Juego */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#4ade80',
          fontSize: '1.125rem',
          fontWeight: '600',
          padding: '0.75rem',
          backgroundColor: 'rgba(0,0,0,0.5)',
          borderRadius: '0 0 8px 8px',
          position: 'relative'
        }}>
          <span>{textos[idioma].level}: {nivel}</span>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            position: 'relative'
          }}>
            <span style={{ 
              color: vidas <= 3 ? '#ff6b6b' : vidas <= 6 ? '#ffd93d' : '#4ade80',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              ❤️ {vidas}/10
            </span>
            
            {mostrarRango && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  fontSize: '0.9rem',
                  fontWeight: 'bold',
                  color: '#fbbf24',
                  textAlign: 'center',
                  padding: '0.3rem 0.8rem',
                  marginTop: '0.3rem',
                  animation: 'rankUpHud 1.5s ease-in-out forwards',
                  backgroundColor: 'rgba(0,0,0,0.9)',
                  borderRadius: '6px',
                  border: '1px solid #fbbf24',
                  boxShadow: '0 2px 8px rgba(251, 191, 36, 0.4)',
                  whiteSpace: 'nowrap',
                  zIndex: 60
                }}
              >
                ⬆️ {textos[idioma].rankup}
              </div>
            )}
          </div>
          <span>{textos[idioma].time}: {tiempo}s</span>
        </div>
      </div>

      {/* Área Central del Juego */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '0 1rem'
      }}>
        <div
          style={{
            color: colorTexto || "transparent",
            fontSize: 'clamp(4rem, 15vw, 8rem)',
            lineHeight: '1.2',
            transition: 'color 0.3s',
            fontWeight: 'bold',
            textAlign: 'center'
          }}
        >
          {inicio && texto}
        </div>
      </div>

      {/* FLASH TIPO DESTELLO */}
      {feedback.visible && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: feedback.tipo === 'acierto' ? 'rgba(74, 222, 128, 0.3)' : 'rgba(239, 68, 68, 0.3)',
            zIndex: 80,
            pointerEvents: 'none',
            animation: 'flash 0.3s ease-out forwards'
          }}
        />
      )}

      {/* Botón Inferior */}
      <div style={{
        width: '100%',
        maxWidth: '400px',
        padding: '0 1rem 1rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }} onClick={(e) => e.stopPropagation()}>
        {!inicio && !gameOver ? (
          <button
            onClick={() => setInicio(true)}
            style={{
              backgroundColor: '#16a34a',
              width: '100%',
              padding: '1rem',
              fontSize: '1.25rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            {textos[idioma].start}
          </button>
        ) : (
          <button
            onClick={reiniciarJuego}
            style={{
              backgroundColor: '#4b5563',
              width: '100%',
              padding: '1rem',
              fontSize: '1.25rem',
              borderRadius: '8px',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            {textos[idioma].restart}
          </button>
        )}
        
        {/* BOTÓN VOLVER AL INICIO */}
        <button
          onClick={() => {
            reiniciarJuego();
            setPantallaInicio(true);
          }}
          style={{
            backgroundColor: '#6b7280',
            padding: '0.75rem',
            fontSize: '1rem',
            borderRadius: '8px',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          ← {textos[idioma].back}
        </button>
      </div>

      {/* GAME OVER CON SISTEMA DE SHARE */}
      {gameOver && !mostrarShare && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '3rem',
            fontWeight: 'bold',
            color: '#ff0000',
            textAlign: 'center',
            zIndex: 50,
            animation: 'gameOverAnimation 2s ease-in-out',
            backgroundColor: 'rgba(0,0,0,0.9)',
            padding: '2rem',
            borderRadius: '15px',
            border: '3px solid #ff0000',
            width: '90%',
            maxWidth: '500px'
          }}
        >
          {textos[idioma].gameOver}
          <div style={{ fontSize: '1.5rem', marginTop: '1rem', color: '#fff' }}>
            {textos[idioma].reachedLevel} {nivel}
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem' }}>
            <button 
              onClick={reiniciarJuego}
              style={{
                padding: '1rem 2rem',
                fontSize: '1.2rem',
                backgroundColor: '#ff0000',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              {textos[idioma].retry}
            </button>
            
            <button 
              onClick={() => setMostrarShare(true)}
              style={{
                padding: '1rem 2rem',
                fontSize: '1.2rem',
                backgroundColor: '#4b5563',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              {textos[idioma].share}
            </button>
          </div>
        </div>
      )}

      {/* PANTALLA DE SHARE MEJORADA CON POSICIÓN */}
      {gameOver && mostrarShare && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            zIndex: 50,
            backgroundColor: 'rgba(0,0,0,0.95)',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #374151',
            width: '90%',
            maxWidth: '400px'
          }}
        >
          <h2 style={{ color: '#fbbf24', fontSize: '1.5rem', marginBottom: '1.5rem' }}>
            {textos[idioma].share}
          </h2>

          {/* Tarjeta visual para compartir */}
          <div
            style={{
              backgroundColor: '#1f2937',
              border: '1px solid #374151',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '1.5rem',
              color: 'white'
            }}
          >
            <div style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: '#fbbf24' }}>
              {textos[idioma].shareTitle}
            </div>
            
            <div style={{ textAlign: 'left', marginBottom: '1rem' }}>
              <div style={{ marginBottom: '0.5rem' }}>👤 {nombreJugador}</div>
              <div style={{ marginBottom: '0.5rem' }}>{banderas[paisJugador]} {paisJugador}</div>
              <div style={{ marginBottom: '0.5rem' }}>⭐ {textos[idioma].level} {nivel}</div>
              <div style={{ marginBottom: '0.5rem' }}>⏱️ {tiempo} {textos[idioma].time.toLowerCase()}</div>
              {/* Posición en el ranking */}
              {miPosicionGlobal && (
                <div style={{ 
                  marginBottom: '0.5rem', 
                  color: '#fbbf24',
                  fontWeight: 'bold',
                  fontSize: '1.1rem'
                }}>
                  🏆 {textos[idioma].position} #{miPosicionGlobal} {textos[idioma].global.toLowerCase()}
                </div>
              )}
            </div>
            
            <div style={{ fontSize: '1rem', color: '#d1d5db', marginBottom: '1rem' }}>
              {textos[idioma].shareChallenge}
            </div>
            
            <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>
              🔗 https://www.colorblink.com/
            </div>
          </div>

          {/* Botones de compartir */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <button 
              onClick={compartirTwitter}
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                backgroundColor: '#1d9bf0',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              🐦 Compartir en Twitter
            </button>
            
            <button 
              onClick={compartirFacebook}
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                backgroundColor: '#1877f2',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              📘 Compartir en Facebook
            </button>
            
            <button 
              onClick={compartirWhatsApp}
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                backgroundColor: '#25d366',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              💬 Compartir en WhatsApp
            </button>
            
            <button 
              onClick={copiarPortapapeles}
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                backgroundColor: '#4b5563',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              📋 Copiar al portapapeles
            </button>
            
            <button 
              onClick={() => setMostrarShare(false)}
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                backgroundColor: '#6b7280',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              ← {textos[idioma].back}
            </button>
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
            20% { opacity: 1; transform: translate(-50%, -50%) scale(1.05); }
            80% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
            100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
          }
          
          @keyframes gameOverAnimation {
            0% { 
              opacity: 0; 
              transform: translate(-50%, -50%) scale(0.5) rotate(-10deg);
            }
            50% { 
              opacity: 1; 
              transform: translate(-50%, -50%) scale(1.1) rotate(5deg);
            }
            100% { 
              opacity: 1; 
              transform: translate(-50%, -50%) scale(1) rotate(0deg);
            }
          }

          @keyframes flash {
            0% { opacity: 0; }
            50% { opacity: 1; }
            100% { opacity: 0; }
          }

          @keyframes rankUpHud {
            0% { 
              opacity: 0; 
              transform: translateX(-50%) translateY(-10px);
            }
            20% { 
              opacity: 1; 
              transform: translateX(-50%) translateY(0);
            }
            80% { 
              opacity: 1; 
              transform: translateX(-50%) translateY(0);
            }
            100% { 
              opacity: 0; 
              transform: translateX(-50%) translateY(-5px);
            }
          }
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          html, body, #root {
            width: 100%;
            height: 100%;
            overflow: hidden;
            /* ✅ NUEVO: ESTILOS ESPECÍFICOS PARA CHROME ANDROID */
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            user-select: none;
          }
        `}
      </style>
    </div>
  );
}
